import moment from 'moment-timezone';

angular.module("dashboard")

    .controller('dashboardListCtrl', ['$rootScope', '$scope', '$filter', 'LoginService', 'Restangular', '$stateParams', '$http', '$interval', '$templateCache', function ($rootScope, $scope, $filter, LoginService, Restangular, $stateParams, $http, $interval, $templateCache) {
        
        $rootScope.title = $filter('translate')('dashboard.dashboard');
        $scope.showCalendar = LoginService.permissionExist("EVENTS_READ");
        $rootScope.breadcrumb = [];

        $scope.urlApi = (window as any).CONFIG.api_url;
        var options = {
            required_image: false,
            show_in_dashboard: true,
            _sortBy: "date_to",
            _sortDirection: "asc"
        };

        let loadEvents = function () {
            Restangular.all('Events').getList(options).then(function (events) {
                $scope.events = events;

                $scope.loadGuestsInfo();
            });
        }

        if (LoginService.permissionExist("EVENTS_READ")) { //Sólo se muestra los eventos, si tiene permiso a ver eventos.

            loadEvents();
        
            $scope.loadGuestsInfo = function () {

                var today = new Date();

                angular.forEach($scope.events, function (item) {
                    let date_from = new Date(item.date_from);

                    item.hours = 0;

                    // Este es el código viejo
                    // item.days = Math.round((date_from.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
                    // Seguía teniendo en cuenta el date_from y el date_to del evento, una información que no se sobreescribe con el check 'all_day'
                    // Esto hacía que según que horas hubiera puestas antes de meter ese check, los eventos entraran en modo monitorizacióna antes de tiempo
                    // Tampoco mostraba nunca las horas hasta la monitorización, ya que hours se quedaba a 0.
                    // Creo que lo correcto es que en ambos casos la formula sea igual, y en caso de ser all_day, en lugar del date_from del evento se utilice
                    // getTime() con las 00:00 del día del evento

                    if (item.all_day) {
                        // Si es todo el día, comparamos con las 00:00 en la zona horaria del evento

                        let timezone = item.timezone;
                        if (timezone == null || timezone == "" || timezone === undefined) timezone = moment.tz.guess();
                        date_from = $scope.toTZDay(item.date_from, item.timezone)
                    } 

                    // En cualquier caso hacemos el cálculo igual
                    item.hours = Math.round((date_from.getTime() - today.getTime()) / 1000 / 60 / 60);

                    if (item.hours > 0) {
                        item.days = 1;
                    } else {
                        item.days = Math.round((date_from.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
                    }
                    
                    if (item.days <= 0) {
                        var params = { event_id: item.id };
                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'Events/getActualEventCounts/',
                            params: params
                        }).then(function (results, status, headers, config) {
                            $scope.invitedGuests = results.data;
                            item.totalGuestsConfirmed = $scope.invitedGuests.total_guests_confirmed;
                            item.totalGuestsNotExpected = $scope.invitedGuests.total_guests_not_expected;
                            item.invitedGuestNotInYet = $scope.invitedGuests.guests_not_in_yet;
                            item.filterGuestsIn = $scope.invitedGuests.guests_in;
                            item.filterGuestsRejected = $scope.invitedGuests.guests_rejected;
                        });
                    }


                });

            };

            let intervalLoadInfoFirstDashboard = $interval(function () { $scope.loadGuestsInfo(); }, (window as any).CONFIG.time_check_changes_guests);
            //Cuando salga del events, se destruirá el intervalo.
            $scope.$on("$destroy", function () {
                if (angular.isDefined(intervalLoadInfoFirstDashboard)) {
                    $interval.cancel(intervalLoadInfoFirstDashboard);
                    intervalLoadInfoFirstDashboard = undefined;
                }
            });

            //set or unset as favourite event
            $scope.eventFavourite = function (event_id) {
                Restangular.all('EventsFavouriteUsers').customPOST({}, "SetOrUnsetFavourite", { event_id: event_id }).then(function (result) {
                    loadEvents();
                });

            }

            // convierte un fecha en una zona horaria determianda y devuelve esa fecha a las 00:00
            $scope.toTZDay = function (date, timezone) {
                return moment
                    .tz(date, timezone)
                    .local()
                    .startOf('day') 
                    .toDate();
            };

        }
    }])

;